var SHARP_CRMC_A780JBEZ = {
  name: "SHARP CRMC A780JBEZ",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [211,0,4,45,15,6,7,43,2,95,1,54,2,37,5,67,2,0,0,165,41,74,82,82,146,74,146,170,85,42,170,149,82,169,84,170,170,170,165,85,85,82,170,170,170,73,37,82,168,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,102,1,47,15,16,7,40,2,37,5,59,2,0,0,102,102,102,76,201,39,39,207,63,207,62,121,255,249,255,231,255,201,36,249,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,80,1,48,15,18,7,57,2,43,5,44,2,0,0,102,102,102,76,201,39,39,207,159,207,62,121,255,249,255,231,255,201,36,243,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,39,2,94,1,61,15,18,7,41,2,43,5,44,2,0,0,102,102,102,76,201,39,39,207,39,243,207,158,127,254,127,249,255,242,73,63,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,97,1,45,15,17,7,40,2,41,5,41,2,0,0,102,102,102,76,201,39,39,207,207,207,62,121,255,249,255,231,255,201,36,242,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,91,1,50,15,14,7,42,2,36,5,45,2,0,0,102,102,102,76,201,39,39,207,51,243,207,158,127,254,127,249,255,242,73,62,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,49,2,91,1,51,15,3,7,53,2,27,5,68,2,0,0,102,102,102,76,201,39,39,207,147,243,207,158,127,254,127,249,255,242,73,60,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,98,1,99,15,16,7,41,2,40,5,43,2,0,0,102,102,102,76,201,39,39,207,36,252,243,231,159,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,39,2,94,1,48,15,15,7,41,2,41,5,44,2,0,0,102,102,102,76,201,39,39,207,231,207,62,121,255,249,255,231,255,201,36,242,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,83,1,58,15,13,7,44,2,37,5,44,2,0,0,102,102,102,76,201,39,39,207,57,243,207,158,127,254,127,249,255,242,73,62,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,77,1,56,15,4,7,45,2,35,5,43,2,0,0,102,102,102,76,201,39,39,207,153,243,207,158,127,254,127,249,255,242,73,60,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,42,2,75,1,43,15,251,6,62,2,43,5,49,2,0,0,102,102,102,76,201,39,39,207,38,124,243,231,159,255,159,254,127,252,146,79,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,79,1,43,15,17,7,55,2,42,5,44,2,0,0,102,102,102,76,201,39,39,207,201,243,207,158,127,254,127,249,255,242,73,60,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,88,1,46,15,14,7,41,2,37,5,41,2,0,0,102,102,102,76,201,39,39,207,50,124,243,231,159,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,87,1,53,15,13,7,40,2,36,5,41,2,0,0,102,102,102,76,201,39,39,207,146,124,243,231,159,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,53,2,88,1,43,15,0,7,59,2,20,5,52,2,0,0,102,102,102,76,201,39,39,207,36,159,60,249,231,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,85,1,39,15,17,7,50,2,41,5,42,2,0,0,102,102,102,76,201,39,39,207,63,207,62,114,127,254,127,249,255,242,73,60,156,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,87,1,48,15,11,7,42,2,37,5,47,2,0,0,102,102,102,76,201,39,39,207,159,207,62,114,127,254,127,249,255,242,73,63,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,90,1,79,15,11,7,40,2,33,5,44,2,0,0,102,102,102,76,201,39,39,207,39,243,207,156,159,255,159,254,127,252,146,79,60,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,91,1,57,15,16,7,38,2,41,5,47,2,0,0,102,102,102,76,201,39,39,207,207,207,62,114,127,254,127,249,255,242,73,62,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [211,0,4,39,2,96,1,45,15,15,7,42,2,37,5,42,2,0,0,102,102,102,76,201,39,39,207,51,243,207,156,159,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,80,1,57,15,7,7,41,2,35,5,43,2,0,0,102,102,102,76,201,39,39,207,147,243,207,156,159,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,91,1,51,15,12,7,41,2,34,5,43,2,0,0,102,102,102,76,201,39,39,207,36,252,243,231,39,255,231,255,159,255,36,147,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,82,1,54,15,11,7,44,2,38,5,41,2,0,0,102,102,102,76,201,39,39,207,231,207,62,114,127,254,127,249,255,242,73,62,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,88,1,59,15,14,7,40,2,38,5,57,2,0,0,102,102,102,76,201,39,39,207,57,243,207,156,159,255,159,254,127,252,146,79,38,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [211,0,4,47,2,96,1,52,15,3,7,50,2,35,5,55,2,0,0,102,102,102,76,201,39,39,207,153,243,207,156,159,255,159,254,127,252,146,79,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [211,0,4,51,2,77,1,47,15,247,6,62,2,29,5,55,2,0,0,102,102,102,76,201,39,39,207,38,124,243,231,39,255,231,255,159,255,36,147,206,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,96,1,55,15,17,7,45,2,43,5,47,2,0,0,102,102,102,76,201,39,39,207,201,243,207,156,159,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,101,1,52,15,17,7,44,2,41,5,45,2,0,0,102,102,102,76,201,39,39,207,50,124,243,231,39,255,231,255,159,255,36,147,201,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [211,0,4,42,2,104,1,55,15,17,7,38,2,42,5,47,2,0,0,102,102,102,76,201,39,39,207,146,124,243,231,39,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_LOW",
      command: [211,0,4,50,2,95,1,43,15,4,7,53,2,24,5,62,2,0,0,102,102,102,76,201,39,39,207,36,159,60,249,201,255,249,255,231,255,201,36,243,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,82,1,58,15,11,7,41,2,36,5,45,2,0,0,102,102,102,76,201,39,39,207,63,207,62,115,63,254,127,249,255,242,73,60,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [211,0,4,41,2,82,1,57,15,9,7,43,2,38,5,44,2,0,0,102,102,102,76,201,39,39,207,159,207,62,115,63,254,127,249,255,242,73,62,76,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [211,0,4,54,2,74,1,51,15,251,6,63,2,26,5,89,2,0,0,102,102,102,76,201,39,39,207,39,243,207,156,207,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [211,0,4,43,2,73,1,45,15,5,7,60,2,43,5,57,2,0,0,102,102,102,76,201,39,39,207,207,207,62,115,63,254,127,249,255,242,73,63,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [211,0,4,53,15,253,6,48,2,92,1,53,2,31,5,68,2,0,0,165,41,74,82,82,146,74,146,170,85,41,85,74,165,84,169,74,170,170,169,85,85,84,170,170,170,146,73,84,170,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,95,1,55,15,15,7,42,2,35,5,42,2,0,0,102,102,102,76,201,39,39,207,147,243,207,156,207,255,159,254,127,252,146,79,156,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [211,0,4,42,2,75,1,49,15,248,6,59,2,40,5,40,2,0,0,102,102,102,76,201,39,39,207,36,252,243,231,51,255,231,255,159,255,36,147,201,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,92,1,54,15,16,7,41,2,41,5,42,2,0,0,102,102,102,76,201,39,39,207,231,207,62,115,63,254,127,249,255,242,73,63,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [211,0,4,57,2,81,1,69,15,252,6,64,2,9,5,63,2,0,0,102,102,102,76,201,39,39,207,57,243,207,156,207,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [211,0,4,50,2,76,1,45,15,3,7,61,2,26,5,57,2,0,0,102,102,102,76,201,39,39,207,153,243,207,156,207,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [211,0,4,42,15,0,7,42,2,102,1,42,2,43,5,41,2,0,0,165,41,74,82,82,146,74,146,170,85,37,42,165,82,170,84,165,85,85,84,170,170,170,85,85,85,73,36,170,73,34],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,103,1,79,15,14,7,40,2,41,5,41,2,0,0,102,102,102,76,201,39,39,207,201,243,207,156,207,255,159,254,127,252,146,79,228,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,96,1,45,15,19,7,54,2,37,5,49,2,0,0,102,102,102,76,201,39,39,207,50,124,243,231,51,255,231,255,159,255,36,147,206,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [211,0,4,64,2,86,1,49,15,212,6,65,2,15,5,57,2,0,0,102,102,102,76,201,39,39,207,146,124,243,231,51,255,231,255,159,255,36,147,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_MID",
      command: [211,0,4,54,2,91,1,46,15,246,6,57,2,20,5,63,2,0,0,102,102,102,76,201,39,39,207,36,159,60,249,204,255,249,255,231,255,201,36,242,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,41,2,100,1,52,15,15,7,43,2,44,5,61,2,0,0,102,102,102,76,201,39,39,207,63,207,62,114,79,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,40,2,87,1,50,15,12,7,43,2,37,5,43,2,0,0,102,102,102,76,201,39,39,207,159,207,62,114,79,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,43,2,81,1,47,15,255,6,54,2,43,5,60,2,0,0,102,102,102,76,201,39,39,207,39,243,207,156,147,255,231,255,159,255,36,147,204,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,54,2,76,1,54,15,246,6,61,2,23,5,63,2,0,0,102,102,102,76,201,39,39,207,207,207,62,114,79,255,159,254,127,252,146,79,156,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,53,2,90,1,45,15,246,6,58,2,17,5,64,2,0,0,102,102,102,76,201,39,39,207,51,243,207,156,147,255,231,255,159,255,36,147,201,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,42,2,79,1,40,15,4,7,58,2,42,5,52,2,0,0,102,102,102,76,201,39,39,207,147,243,207,156,147,255,231,255,159,255,36,147,252,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,54,2,83,1,53,15,252,6,58,2,25,5,72,2,0,0,102,102,102,76,201,39,39,207,36,252,243,231,36,255,249,255,231,255,201,36,243,196],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,41,2,76,1,52,15,17,7,57,2,43,5,42,2,0,0,102,102,102,76,201,39,39,207,231,207,62,114,79,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,42,2,96,1,55,15,14,7,43,2,41,5,47,2,0,0,102,102,102,76,201,39,39,207,57,243,207,156,147,255,231,255,159,255,36,147,201,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,43,2,103,1,74,15,17,7,42,2,42,5,45,2,0,0,102,102,102,76,201,39,39,207,153,243,207,156,147,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,40,2,99,1,69,15,18,7,40,2,40,5,41,2,0,0,102,102,102,76,201,39,39,207,38,124,243,231,36,255,249,255,231,255,201,36,243,36,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,41,2,82,1,52,15,11,7,42,2,28,5,46,2,0,0,102,102,102,76,201,39,39,207,201,243,207,156,147,255,231,255,159,255,36,147,230,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,44,2,99,1,41,15,246,6,47,2,30,5,41,2,0,0,102,102,102,76,201,39,39,207,50,124,243,231,36,255,249,255,231,255,201,36,242,100,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,45,2,77,1,43,15,252,6,58,2,33,5,58,2,0,0,102,102,102,76,201,39,39,207,146,124,243,231,36,255,249,255,231,255,201,36,254,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,42,2,77,1,44,15,255,6,57,2,42,5,44,2,0,0,102,102,102,76,201,39,39,207,36,159,60,249,201,63,254,127,249,255,242,73,60,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,96,1,53,15,16,7,46,2,43,5,45,2,0,0,102,102,102,76,201,39,39,207,63,207,60,249,255,249,255,231,255,201,36,243,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,73,1,46,15,16,7,66,2,43,5,56,2,0,0,102,102,102,76,201,39,39,207,159,207,60,249,255,249,255,231,255,201,36,249,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,54,2,89,1,47,15,249,6,58,2,22,5,68,2,0,0,102,102,102,76,201,39,39,207,39,243,207,62,127,254,127,249,255,242,73,60,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,43,2,98,1,48,15,248,6,51,2,35,5,60,2,0,0,102,102,102,76,201,39,39,207,207,207,60,249,255,249,255,231,255,201,36,252,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,41,2,91,1,41,15,17,7,43,2,41,5,50,2,0,0,102,102,102,76,201,39,39,207,51,243,207,62,127,254,127,249,255,242,73,60,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,42,2,98,1,51,15,247,6,48,2,33,5,49,2,0,0,102,102,102,76,201,39,39,207,147,243,207,62,127,254,127,249,255,242,73,62,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,40,2,99,1,49,15,4,7,41,2,45,5,45,2,0,0,102,102,102,76,201,39,39,207,36,252,243,207,159,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,52,2,96,1,46,15,228,6,54,2,27,5,51,2,0,0,102,102,102,76,201,39,39,207,231,207,60,249,255,249,255,231,255,201,36,254,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,55,2,73,1,54,15,247,6,66,2,21,5,56,2,0,0,102,102,102,76,201,39,39,207,57,243,207,62,127,254,127,249,255,242,73,60,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,51,2,71,1,79,15,247,6,71,2,21,5,55,2,0,0,102,102,102,76,201,39,39,207,153,243,207,62,127,254,127,249,255,242,73,62,100,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,49,2,95,1,45,15,255,6,51,2,21,5,43,2,0,0,102,102,102,76,201,39,39,207,38,124,243,207,159,255,159,254,127,252,146,79,38,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,43,2,83,1,53,15,252,6,57,2,35,5,43,2,0,0,102,102,102,76,201,39,39,207,201,243,207,62,127,254,127,249,255,242,73,63,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,50,2,79,1,44,15,1,7,60,2,0,5,39,2,0,0,102,102,102,76,201,39,39,207,50,124,243,207,159,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,48,2,95,1,45,15,3,7,49,2,24,5,43,2,0,0,102,102,102,76,201,39,39,207,146,124,243,207,159,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,45,2,97,1,50,15,246,6,49,2,33,5,57,2,0,0,102,102,102,76,201,39,39,207,36,159,60,243,231,255,231,255,159,255,36,147,201,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [211,0,4,48,2,94,1,39,15,4,7,55,2,26,5,65,2,0,0,102,102,102,76,201,39,39,207,63,207,60,242,127,254,127,249,255,242,73,63,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,96,1,48,15,15,7,40,2,38,5,41,2,0,0,102,102,102,76,201,39,39,207,159,207,60,242,127,254,127,249,255,242,73,60,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,75,1,51,15,18,7,62,2,44,5,56,2,0,0,102,102,102,76,201,39,39,207,39,243,207,60,159,255,159,254,127,252,146,79,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,105,1,56,15,15,7,39,2,44,5,60,2,0,0,102,102,102,76,201,39,39,207,207,207,60,242,127,254,127,249,255,242,73,60,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [211,0,4,50,2,78,1,55,15,8,7,50,2,35,5,63,2,0,0,102,102,102,76,201,39,39,207,51,243,207,60,159,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [211,0,4,41,2,72,1,69,15,250,6,66,2,32,5,55,2,0,0,102,102,102,76,201,39,39,207,147,243,207,60,159,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [211,0,4,42,2,75,1,51,15,250,6,58,2,42,5,54,2,0,0,102,102,102,76,201,39,39,207,36,252,243,207,39,255,231,255,159,255,36,147,228,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,97,1,45,15,18,7,41,2,41,5,41,2,0,0,102,102,102,76,201,39,39,207,231,207,60,242,127,254,127,249,255,242,73,60,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [211,0,4,43,2,98,1,45,15,255,6,50,2,29,5,41,2,0,0,102,102,102,76,201,39,39,207,57,243,207,60,159,255,159,254,127,252,146,79,228,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,84,1,56,15,8,7,40,2,35,5,44,2,0,0,102,102,102,76,201,39,39,207,153,243,207,60,159,255,159,254,127,252,146,79,38,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [211,0,4,42,2,98,1,43,15,5,7,47,2,32,5,47,2,0,0,102,102,102,76,201,39,39,207,38,124,243,207,39,255,231,255,159,255,36,147,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [211,0,4,40,2,85,1,72,15,13,7,41,2,38,5,41,2,0,0,102,102,102,76,201,39,39,207,201,243,207,60,159,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [211,0,4,39,2,93,1,85,15,15,7,41,2,38,5,43,2,0,0,102,102,102,76,201,39,39,207,50,124,243,207,39,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_LOW",
      command: [211,0,4,44,2,98,1,40,15,249,6,46,2,34,5,43,2,0,0,102,102,102,76,201,39,39,207,146,124,243,207,39,255,231,255,159,255,36,147,201,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_LOW",
      command: [211,0,4,39,2,73,1,50,15,15,7,52,2,42,5,47,2,0,0,102,102,102,76,201,39,39,207,36,159,60,243,201,255,249,255,231,255,201,36,249,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [211,0,4,43,2,98,1,45,15,1,7,47,2,44,5,56,2,0,0,102,102,102,76,201,39,39,207,63,207,60,243,63,254,127,249,255,242,73,62,76,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [211,0,4,41,2,92,1,48,15,18,7,45,2,43,5,54,2,0,0,102,102,102,76,201,39,39,207,159,207,60,243,63,254,127,249,255,242,73,60,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [211,0,4,41,2,99,1,53,15,3,7,47,2,44,5,50,2,0,0,102,102,102,76,201,39,39,207,39,243,207,60,207,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,71,1,45,15,18,7,65,2,34,5,66,2,0,0,102,102,102,76,201,39,39,207,207,207,60,243,63,254,127,249,255,242,73,60,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [211,0,4,51,2,92,1,48,15,1,7,60,2,18,5,72,2,0,0,102,102,102,76,201,39,39,207,51,243,207,60,207,255,159,254,127,252,146,79,156,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [211,0,4,41,2,95,1,49,15,19,7,44,2,43,5,57,2,0,0,102,102,102,76,201,39,39,207,147,243,207,60,207,255,159,254,127,252,146,79,60,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [211,0,4,52,2,93,1,41,15,252,6,55,2,26,5,69,2,0,0,102,102,102,76,201,39,39,207,36,252,243,207,51,255,231,255,159,255,36,147,252,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [211,0,4,52,15,3,7,51,2,73,1,63,2,27,5,54,2,0,0,165,41,74,82,82,146,74,146,170,85,84,170,149,74,165,82,149,85,85,82,170,170,169,85,85,85,36,146,169,36,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [211,0,4,46,2,93,1,54,15,250,6,52,2,26,5,54,2,0,0,102,102,102,76,201,39,39,207,57,243,207,60,207,255,159,254,127,252,146,79,146,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [211,0,4,48,2,73,1,43,15,245,6,65,2,36,5,43,2,0,0,102,102,102,76,201,39,39,207,153,243,207,60,207,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [211,0,4,42,2,98,1,50,15,4,7,49,2,40,5,46,2,0,0,102,102,102,76,201,39,39,207,38,124,243,207,51,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [211,0,4,50,2,95,1,55,15,244,6,55,2,20,5,54,2,0,0,102,102,102,76,201,39,39,207,201,243,207,60,207,255,159,254,127,252,146,79,38,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [211,0,4,43,2,94,1,44,15,3,7,54,2,25,5,46,2,0,0,102,102,102,76,201,39,39,207,50,124,243,207,51,255,231,255,159,255,36,147,230,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_MID",
      command: [211,0,4,40,2,87,1,68,15,15,7,42,2,37,5,42,2,0,0,102,102,102,76,201,39,39,207,146,124,243,207,51,255,231,255,159,255,36,147,206,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_MID",
      command: [211,0,4,41,2,96,1,49,15,17,7,43,2,43,5,44,2,0,0,102,102,102,76,201,39,39,207,36,159,60,243,204,255,249,255,231,255,201,36,254,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,54,2,93,1,45,15,251,6,57,2,24,5,93,2,0,0,102,102,102,76,201,39,39,207,63,207,60,242,79,255,159,254,127,252,146,79,204,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,53,2,91,1,45,15,252,6,55,2,26,5,85,2,0,0,102,102,102,76,201,39,39,207,159,207,60,242,79,255,159,254,127,252,146,79,36,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,52,2,88,1,49,15,2,7,60,2,19,5,65,2,0,0,102,102,102,76,201,39,39,207,39,243,207,60,147,255,231,255,159,255,36,147,228,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,50,2,73,1,53,15,3,7,71,2,23,5,59,2,0,0,102,102,102,76,201,39,39,207,207,207,60,242,79,255,159,254,127,252,146,79,60,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,54,2,77,1,42,15,251,6,65,2,23,5,65,2,0,0,102,102,102,76,201,39,39,207,51,243,207,60,147,255,231,255,159,255,36,147,252,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,47,15,224,6,65,2,84,1,61,2,10,5,82,2,0,0,165,41,74,82,82,146,74,146,170,85,73,85,74,165,82,169,37,85,85,84,170,170,170,85,85,85,73,36,170,74,136],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,55,2,87,1,48,15,246,6,63,2,17,5,78,2,0,0,102,102,102,76,201,39,39,207,36,252,243,207,36,255,249,255,231,255,201,36,249,196],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,53,2,90,1,44,15,255,6,61,2,19,5,56,2,0,0,102,102,102,76,201,39,39,207,231,207,60,242,79,255,159,254,127,252,146,79,50,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,44,2,84,1,53,15,253,6,59,2,35,5,58,2,0,0,102,102,102,76,201,39,39,207,57,243,207,60,147,255,231,255,159,255,36,147,242,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,48,15,242,6,54,2,97,1,52,2,24,5,57,2,0,0,165,41,74,82,82,146,74,146,170,85,74,85,74,165,82,169,37,85,85,84,170,170,170,85,85,85,73,36,170,73,34],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,50,2,74,1,55,15,255,6,64,2,21,5,57,2,0,0,102,102,102,76,201,39,39,207,38,124,243,207,36,255,249,255,231,255,201,36,249,36,64],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,55,2,86,1,43,15,248,6,60,2,19,5,68,2,0,0,102,102,102,76,201,39,39,207,201,243,207,60,147,255,231,255,159,255,36,147,206,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,44,2,95,1,46,15,0,7,49,2,44,5,44,2,0,0,102,102,102,76,201,39,39,207,50,124,243,207,36,255,249,255,231,255,201,36,254,68],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_31",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,49,15,248,6,54,2,75,1,63,2,24,5,86,2,0,0,165,41,74,82,82,146,74,146,170,85,73,42,165,82,169,84,146,170,170,170,85,85,85,42,170,170,164,146,85,37,34],
    },
    {
      mode: "AC_MODE_HEAT",
      temperature: "AC_TEMP_32",
      fan: "AC_FAN_HIGH",
      command: [211,0,4,57,2,88,1,50,15,243,6,60,2,16,5,55,2,0,0,102,102,102,76,201,39,39,207,36,159,60,243,201,63,254,127,249,255,242,73,62,100,64],
    },
    ////////////////////////////////////////////////////////
    {
		mode: "AC_MODE_DRY",
		temperature: "AC_TEMP_DRY_N2",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,53,2,82,1,46,15,252,6,57,2,27,5,53,2,0,0,102,102,102,76,201,39,39,207,249,147,201,201,231,255,231,255,156,255,201,36,249,36,64],
	},
	{
		mode: "AC_MODE_DRY",
		temperature: "AC_TEMP_DRY_N1",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,54,2,89,1,44,15,244,6,52,2,29,5,66,2,0,0,102,102,102,76,201,39,39,207,243,147,201,201,231,255,231,255,156,255,201,36,243,36,64],
	},
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [211,0,4,52,2,93,1,44,15,255,6,55,2,23,5,59,2,0,0,102,102,102,76,201,39,39,207,255,60,242,121,255,249,255,231,255,201,36,249,196],
    },
    {
		mode: "AC_MODE_DRY",
		temperature: "AC_TEMP_DRY_1",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,71,2,62,1,56,15,220,6,71,2,11,5,114,2,0,0,102,102,102,76,201,39,39,207,243,207,39,39,159,255,159,254,115,255,36,147,204,196],
	},
	{
		mode: "AC_MODE_DRY",
		temperature: "AC_TEMP_DRY_2",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,46,2,96,1,44,15,2,7,52,2,32,5,93,2,0,0,102,102,102,76,201,39,39,207,249,207,39,39,159,255,159,254,115,255,36,147,228,196],
	},
    ////////////////////////////AUTO//////////////////////////////////
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N2",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,60,2,62,1,2,15,41,7,69,2,13,5,69,2,0,0,102,102,102,76,201,39,39,207,249,147,201,254,127,254,127,249,207,252,146,79,50,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N1",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,60,2,57,1,54,15,247,6,89,2,4,5,68,2,0,0,102,102,102,76,201,39,39,207,243,147,201,254,127,254,127,249,207,252,146,79,146,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_NULL",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,54,2,77,1,47,15,253,6,66,2,24,5,76,2,0,0,102,102,102,76,201,39,39,207,255,60,255,159,255,159,254,127,252,146,79,60,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_1",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,68,2,58,1,80,15,243,6,90,2,10,5,91,2,0,0,102,102,102,76,201,39,39,207,243,207,39,249,255,249,255,231,63,242,73,62,76,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_2",
		fan: "AC_FAN_AUTO",
		command: [211,0,4,58,2,72,1,67,15,243,6,68,2,11,5,85,2,0,0,102,102,102,76,201,39,39,207,249,207,39,249,255,249,255,231,63,242,73,60,204,64],
	},
	/////////////////////////////////////////////////////////////
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N2",
		fan: "AC_FAN_LOW",
		command: [211,0,4,69,2,58,1,53,15,234,6,78,2,7,5,82,2,0,0,102,102,102,76,201,39,39,207,249,147,201,252,159,255,159,254,115,255,36,147,242,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N1",
		fan: "AC_FAN_LOW",
		command: [211,0,4,64,2,60,1,71,15,222,6,70,2,8,5,75,2,0,0,102,102,102,76,201,39,39,207,243,147,201,252,159,255,159,254,115,255,36,147,201,36,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_NULL",
		fan: "AC_FAN_LOW",
		command: [211,0,4,53,2,77,1,50,15,254,6,67,2,25,5,68,2,0,0,102,102,102,76,201,39,39,207,255,60,255,39,255,231,255,159,255,36,147,252,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_1",
		fan: "AC_FAN_LOW",
		command: [211,0,4,59,2,62,1,89,15,248,6,72,2,7,5,83,2,0,0,102,102,102,76,201,39,39,207,243,207,39,242,127,254,127,249,207,252,146,79,36,196],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_2",
		fan: "AC_FAN_LOW",
		command: [211,0,4,55,2,64,1,71,15,240,6,69,2,7,5,84,2,0,0,102,102,102,76,201,39,39,207,249,207,39,242,127,254,127,249,207,252,146,79,204,64],
	},
	/////////////////////////////////////////////////////////
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N2",
		fan: "AC_FAN_MID",
		command: [211,0,4,61,2,69,1,54,15,242,6,70,2,13,5,69,2,0,0,102,102,102,76,201,39,39,207,249,147,201,252,207,255,159,254,115,255,36,147,230,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N1",
		fan: "AC_FAN_MID",
		command: [211,0,4,60,2,63,1,61,15,236,6,72,2,7,5,72,2,0,0,102,102,102,76,201,39,39,207,243,147,201,252,207,255,159,254,115,255,36,147,206,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_NULL",
		fan: "AC_FAN_MID",
		command: [211,0,4,42,2,78,1,47,15,10,7,64,2,29,5,66,2,0,0,102,102,102,76,201,39,39,207,255,60,255,51,255,231,255,159,255,36,147,228,196],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_1",
		fan: "AC_FAN_MID",
		command: [211,0,4,61,2,76,1,48,15,241,6,66,2,13,5,76,2,0,0,102,102,102,76,201,39,39,207,243,207,39,243,63,254,127,249,207,252,146,79,60,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_2",
		fan: "AC_FAN_MID",
		command: [211,0,4,52,2,73,1,51,15,1,7,71,2,22,5,66,2,0,0,102,102,102,76,201,39,39,207,249,207,39,243,63,254,127,249,207,252,146,79,156,64],
	},
	/////////////////////////////////////////////////////
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N2",
		fan: "AC_FAN_HIGH",
		command: [211,0,4,54,2,84,1,70,15,0,7,57,2,24,5,62,2,0,0,102,102,102,76,201,39,39,207,249,147,201,252,147,255,231,255,156,255,201,36,254,68],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_N1",
		fan: "AC_FAN_HIGH",
		command: [211,0,4,60,2,68,1,53,15,239,6,69,2,8,5,61,2,0,0,102,102,102,76,201,39,39,207,243,147,201,252,147,255,231,255,156,255,201,36,242,100,64],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_NULL",
		fan: "AC_FAN_HIGH",
		command: [211,0,4,64,2,60,1,55,15,242,6,70,2,9,5,86,2,0,0,102,102,102,76,201,39,39,207,255,60,255,36,255,249,255,231,255,201,36,252,196],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_1",
		fan: "AC_FAN_HIGH",
		command: [211,0,4,57,2,69,1,54,15,250,6,67,2,10,5,84,2,0,0,102,102,102,76,201,39,39,207,243,207,39,242,79,255,159,254,115,255,36,147,201,196],
	},
	{
		mode: "AC_MODE_AUTO",
		temperature: "AC_TEMP_AUTO_2",
		fan: "AC_FAN_HIGH",
		command: [211,0,4,60,2,61,1,72,15,241,6,71,2,4,5,108,2,0,0,102,102,102,76,201,39,39,207,249,207,39,242,79,255,159,254,115,255,36,147,252,64],
	},
    ]
};

export default SHARP_CRMC_A780JBEZ
